import { __assign } from "tslib";
import * as React from 'react';
import { memo } from 'react';
var SvgMore = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img" }, props),
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m4 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2", clipRule: "evenodd" }))); };
var Memo = memo(SvgMore);
export default Memo;
//# sourceMappingURL=More.js.map